export const metadataToArray = (metadata?: string) => metadata?.split(',').filter(value => value)
